/**
 * @fileoverview Detail section heading.
 * @description The small heading that groups a detail dialog's fields into sections (e.g. View
 * User's "Contact Details" / "Organisation Details" / "Account Status").
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

interface DetailSectionHeadingProps {
  children: string
}

/**
 * @component
 * @param {DetailSectionHeadingProps} props - The section's label.
 * @param {string} props.children - The section's label.
 */
function DetailSectionHeading({ children }: DetailSectionHeadingProps) {
  return <p className="text-[11px] font-bold tracking-[0.8px] text-kicker">{children}</p>
}

export default DetailSectionHeading
